import React, { useState, useEffect } from 'react';
import { userAPI } from '../services/api';
import '../styles/Whot.css';

export const WhotWeeklyLeaderboard = () => {
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchLeaderboard();
  }, []);

  const fetchLeaderboard = async () => {
    try {
      setLoading(true);
      const response = await userAPI.getLeaderboard('whot_weekly', 10);
      setLeaderboard(response.data || []);
      setError('');
    } catch (error) {
      console.error('Failed to fetch weekly leaderboard:', error);
      setError('Failed to load rankings');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="weekly-loader">Loading rankings...</div>;
  if (error) return <div className="weekly-error">{error}</div>;

  return (
    <div className="weekly-leaderboard-content">
      <div className="weekly-list">
        {leaderboard.length === 0 ? (
          <div className="empty-weekly">No rankings yet this week</div>
        ) : (
          leaderboard.map((player, index) => (
            <div key={player.id} className={`weekly-item rank-${index + 1}`}>
              <div className="weekly-rank">
                {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : `#${index + 1}`}
              </div>
              <div className="weekly-player">
                <span className="player-name">{player.username}</span>
              </div>
              <div className="weekly-score-main">
                {index === 0 && <span className="trophy-icon" title="1st Place">🏆</span>}
                {index === 1 && <span className="trophy-icon" title="2nd Place">🏆</span>}
                {index === 2 && <span className="trophy-icon" title="3rd Place">🏆</span>}
              </div>
            </div>
          ))
        )}
      </div>
      
      <div className="weekly-footer">
        Only Real Challenges count towards the leaderboard.<br/>
        Resets every Monday at 00:00 UTC
      </div>
    </div>
  );
};

